import moment from 'moment';

import { useRouter } from '../../../../contexts/RouterContext';
import { nuc } from '../../../../utils';
import Button from '../../../generic/Button/Button';
import { icons } from '../../../generic/Icon/icons';
import { Icon, IconAndNode, IconText } from '../../../generic/Icon/index';
import { Link } from '../../../generic/Link/index';
import type { Repository } from '../../../../types';

import RowTitle from './RowTitle';

import styles from './ImportedProjectRow.module.less';

type ImportedProjectRowProps = {
  repo: Repository;
};

const ImportedProjectRow = ({ repo }: ImportedProjectRowProps) => {
  const router = useRouter();
  let updatedAt = '';
  if (repo.updated) {
    updatedAt = moment(repo.updated).fromNow();
  } else if (repo.updated_at) {
    updatedAt = moment(repo.updated_at).fromNow();
  }

  // When determining how to link to this project within FOSSA, first check
  // if the project was imported normally (via the repo.project field). If that
  // doesn't exist, fallback to checking if the project has been connected.
  const projectLocator = repo.project?.locator ?? repo.connectedProjects?.[0];
  const navigateToProject = () => {
    if (projectLocator) {
      router.push(`/projects/${nuc(projectLocator)}`);
    }
  };

  return (
    <button
      type="button"
      className={styles.row}
      onClick={navigateToProject}
    >
      <span className={styles.checkbox}>
        <Link to={repo.url as string} openInNewTab shouldStopPropagation>
          <Icon icon={icons.externalLink} />
        </Link>
      </span>
      <RowTitle repo={repo} />
      <span className={styles.branch}>
        {repo.branch &&
          <IconText
            icon={icons.codeBranch}
            text={repo.branch}
          />}
      </span>
      <span className={styles.status}>
        <IconText
          icon={icons.check}
          text={updatedAt}
        />
      </span>
      <div>
        <Button onClick={navigateToProject} type="secondary" testId="repo-action-view">
          <IconAndNode
            icon={icons.externalLink}
            alignIcon="right"
            marginAmount="8px"
          >
            View
          </IconAndNode>
        </Button>
      </div>
    </button>
  );
};

export default ImportedProjectRow;
